
import { FailedToNegotiateWithServerError } from "@microsoft/signalr/dist/esm/Errors";
import { mapState, mapMutations } from "vuex";

import run_sound from "@/assets/audio/lightningStrike_1.mp3";
import win_sound from "@/assets/audio/crashFinal.mp3";
import wait_sound from "@/assets/audio/timerCountdown.mp3";
export default {
	name: 'CrashBox',

	components: {
	},

	filters: {

	},


	data() {
		return {
			GAME_STATES: {
				NotStarted: 'NotStarted',
				Starting: 'Starting',
				InProgress: 'InProgress',
				Over: 'Over',
				Blocking: 'Blocking',
				Refunded: 'Refunded',
				Crash: 'Crash',
			},
			player: null,
			town: null,
			timer: null,
			currentAnimation: null,
			app: null,
			sounds: null
		};
	},
	props: ['gameState'],
	watch: {
		gameState: {
			handler(val) {
				this.handleGameStateChange(val);
			},
			deep: true,
			immediate: true
		}
	},
	computed: {
		...mapState(["user",
			"isMute"]),
	},
	created() {
		var sounds = {
			run: new Audio(run_sound),
			win: new Audio(win_sound),
			wait: new Audio(wait_sound)
		};
		this.sounds = sounds;

	},
	mounted() {
		this.initPixi();
	},
	beforeDestroy() {
		console.log("CrashBox beforeDestroy: 清理资源和事件监听器");
		// 1. 移除事件与动画
		window.removeEventListener('resize', this.onResize);
		gsap.killTweensOf(this.player);
		this.stopAllSounds();


		// 3. 销毁 App
		if (this.app) {
			this.app.destroy(true, { children: true, texture: false, baseTexture: false });
			this.app = null;
		}

	},

	methods: {
		...mapMutations([]),
		async initPixi() {
			// 1. 初始化 Pixi Application
			this.app = new window.PIXI.Application({
				width: this.$refs.gameBox.clientWidth,
				height: this.$refs.gameBox.clientHeight,
                antialias: false, // 禁用抗锯齿
                preserveDrawingBuffer: false, // 禁用缓冲区保留
				view: this.$refs.gameContainer
			});

			// 开始加载
			const spinTown = await this.loadTexture('town', '/static/crash/new_crash111.json');
			const spinPlayer = await this.loadTexture('player', '/static/crash/gg_crash.json');

			const townObj = new window.PIXI.spine.Spine(spinTown.spineData);
			const playerObj = new window.PIXI.spine.Spine(spinPlayer.spineData);

			let isMobile = this.$screen.mobile;
			// 4. 应用设置
			townObj.x = isMobile ? -913 : -90;
			townObj.scale.set(isMobile ? .693 : 0.3);
			this.app.stage.addChild(townObj);


			playerObj.x = isMobile ? 550 : 500;
			playerObj.y = isMobile ? 660 : 250;
			playerObj.scale.set(isMobile ? 0.28 : 0.1);
			playerObj.visible = false;
			this.app.stage.addChild(playerObj);

			this.player = playerObj;
			this.town = townObj;

			// 5. 播放动画
			this.town.state.setAnimation(0, '1_idle', true);
			this.player.state.setAnimation(0, 'idle', true);

			window.addEventListener('resize', this.onResize);
			this.onResize();

		},
		async loadTexture(name, url) {
			if (!window.PIXI.Assets.get(name)) {
				window.PIXI.Assets.add(name, url);
			}

			let texture = window.PIXI.Assets.get(name);
			if (!texture) {
				texture = await window.PIXI.Assets.load(name);
			}
			return texture;
		},
		stopAllSounds() {
			for (const key in this.sounds) {
				const sound = this.sounds[key];
				if (sound) {

					sound.currentTime = 0;   // 重置进度
					sound.loop = false;      // 取消循环，防止再次触发
					sound.pause();           // 暂停播放
				}
			}
		},
		playSound(soundName) {
			this.stopAllSounds();

			if (this.isMute) return; // 如果静音，直接返回

			const sound = this.sounds[soundName];
			if (!sound) return;
			sound.loop = true;
			sound.currentTime = 0;
			sound.play();

		},
		transitionTo(target, animName, loop = true) {
			if (!target || !target.state) return;
			// 使用 0 号轨道，第三个参数是循环，第四个参数是可选的延迟
			target.state.setAnimation(0, animName, loop);
		},
		onResize() {
			console.log("窗口大小改变，重新调整 Pixi 画布大小");
			if (!this.app || !this.$refs.gameContainer) return;

			// 1. 获取父容器的实际尺寸
			const parentWidth = this.$refs.gameContainer.clientWidth;
			const parentHeight = this.$refs.gameContainer.clientHeight;

			// 2. 调整渲染器分辨率（保持画布清晰）
			this.app.renderer.resize(parentWidth, parentHeight);

			// 3. 计算缩放比例
			// 假设设计稿基准宽度是 1200
			const baseWidth = 800;
			const baseHeight = 400;
			const scale = parentWidth / baseWidth;

			// 4. 将比例应用到舞台 (stage)
			// 这样舞台内所有的 Spine、图片、文字都会自动按比例缩放
			this.app.stage.scale.set(scale);
		},
		moveSpineTo(targetX, duration = 1) {
			if (!this.player) return;

			// 使用 GSAP 平滑移动
			gsap.to(this.player, {
				x: targetX,
				duration: duration,
				ease: "power2.out", // 使用缓动函数，让移动更自然
				onUpdate: () => {
					// 如果需要每帧执行额外逻辑，可以在这里写
				},
				onComplete: () => {
					console.log("移动完成");
				}
			});
		},
		// 监听状态变化
		handleGameStateChange(val) {
			// 确保实例已加载
			if (!this.player || !this.town) return;

			let isMobile = this.$screen.mobile;

			switch (val) {
				case this.GAME_STATES.Starting:
					this.player.x = isMobile ? 550 : 500;
					// 先播 idle，播完自动转 run
					this.player.state.setAnimation(0, "idle", false);
					this.town.state.setAnimation(0, "1_idle", true);
					this.playSound('wait');
					break;

				case this.GAME_STATES.InProgress:
					this.transitionTo(this.player, "run", true);
					this.moveSpineTo(isMobile ? 1099 : 860, 3); // 移动到 x=860，持续 3 秒
					this.transitionTo(this.town, "2_start_game", true);
					this.playSound('run');
					break;
				case this.GAME_STATES.Crash:
					this.transitionTo(this.player, "dead", false);
					this.transitionTo(this.town, "3_crush", true);
					this.playSound('win');
					break;

				case this.GAME_STATES.Over:
					this.transitionTo(this.player, "dead", false);
					this.transitionTo(this.town, "4_victory", false);
					this.playSound('win');
					break;
			}
		}

	},

}
